/** @jsx jsx */
import React, { type PropsWithChildren } from 'react';
import { css, jsx } from '@compiled/react';
import AkAvatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';
import WithProfileCard from '@atlassian/jira-issue-view-internal-profilecard-next/src/index.tsx';
import type { User } from '@atlassian/jira-issue-shared-types/src/common/types/user-type.tsx';

type Props = {
	user?: User;
	isNested?: boolean;
};
const Avatar = ({ user, isNested }: PropsWithChildren<Props>) => {
	return (
		<div css={[avatarStyles, isNested && nestedStyles]}>
			<WithProfileCard
				userAccount={user}
				analyticsData={{ trigger: 'comment-avatar' }}
				testId="comment.ui.header.avatar"
				ariaHideProfileTrigger
			>
				<AkAvatar borderColor="transparent" size="medium" src={user?.avatarUrl} />
			</WithProfileCard>
		</div>
	);
};

const avatarStyles = css({
	gridArea: 'header-avatar',
});

const nestedStyles = css({
	maxWidth: 'calc(100% - 32px)',
	position: 'relative',
	'--commentsLineWidth': '1px',
	'--childTailWidth': token('space.200'),
	'--commentLineColor': token('color.background.accent.gray.subtler'),
	'&::after': {
		content: '',
		boxSizing: 'border-box',
		position: 'absolute',
		insetInlineStart: 'var(--commentInlineStart)',
		top: 'calc(-50% - 9px)',
		width: 'var(--childTailWidth)',
		borderInlineStart: 'var(--commentsLineWidth) solid var(--commentLineColor)',
		borderBottom: 'var(--commentsLineWidth) solid var(--commentLineColor)',
		backgroundColor: token('color.background.neutral.subtle'),
		borderEndStartRadius: token('space.100'),
		height: '100%',
		// Avatar width + profile card margin - should be removed once thread lines support is fully implemented
		left: '-26px',
	},
});

export default Avatar;
